import { motion } from "framer-motion";

/** Standard scroll-reveal for Books pages (framer-motion, once, expo-out).
 * `js-reveal` is a stable hook (see index.css @media print) so review/PDF
 * capture tools can never freeze this content at its hidden initial state. */
export default function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={`js-reveal ${className}`}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -60px 0px" }}
      transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1], delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
